import {Action} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';

export class LoginErrorAction implements Action {
  public static readonly type = 'LoginErrorAction';

  constructor(public error: HttpErrorResponse) {
  }

  public type = LoginErrorAction.type;
}
